/**
 * PC 등록 화면의 번호 붙은 구역 머리(시안 1288:21089 "Section Header").
 * 번호 배지의 #ececec 는 시안에도 변수가 아니라 원시 hex 다 — 대응하는 토큰이 없어 그대로 적었다.
 */
export function SectionHeader({
  no,
  title,
  desc,
}: {
  no: string
  title: string
  desc: string
}) {
  return (
    <div className="flex w-full flex-col items-start gap-2">
      <span className="flex flex-col items-center justify-center rounded-lg bg-[#ececec] px-[11px] text-body-md text-black-200">
        {no}
      </span>
      <div className="flex w-full flex-col items-start gap-[5px]">
        <p className="m-0 w-full text-headline-xs font-medium tracking-[-0.1px] text-black-800">
          {title}
        </p>
        <p className="m-0 text-body-md text-black-200">{desc}</p>
      </div>
    </div>
  )
}
